import { createStore } from 'vuex'

// Get our initial data for the store, with defaults in case it's undefined
const {
  name = '',
  image = {},
  notifierMessage = '',
  notifierType = ''
} = { ...window.ecoonline?.initialData }

export default createStore({
  state: {
    user: {
      name,
      image
    },
    notifier: {
      message: notifierMessage,
      type: notifierType,
      autoHide: false
    }
  },
  getters: {
    userImageUrl (state) {
      const url = state.user.image?.url ?? ''
      return url.replace('/index.php', '')
    }
  },
  mutations: {
    updateStoredUser (state, data) {
      state.user = {
        ...state.user,
        ...data
      }
    },
    updateNotifier (state, data) {
      state.notifier = {
        ...data,
        autoHide: !!data.autoHide
      }
    }
  }
})
